export enum TypographyLineHeight {
    Small = "1.25",
    Normal = "1.5",
    Large = "2",
}
